<template>
  <el-dialog :title="$t('role.edit')" :visible.sync="visible" width="40%" @close="resetForm">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item :label="$t('role.name')" prop="name">
        <el-input v-model="form.name" :placeholder="$t('role.requiredName')" />
      </el-form-item>

      <el-form-item :label="$t('role.description')" prop="description">
        <el-input v-model="form.description" type="textarea" :placeholder="$t('role.descriptionLength')" />
      </el-form-item>

      <el-form-item label="绑定职位" prop="relCd">
        <el-select v-model="form.relCd" placeholder="请选择" style="width: 100%">
          <el-option
            v-for="item in relCdOptions"
            :key="item.statusCd"
            :label="item.name"
            :value="item.statusCd"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('role.cancel') }}</el-button>
      <el-button type="primary" @click="submitForm">{{ $t('role.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updatePrivilegeGroup } from '@/api/role/roleApi'
import { getDictList } from '@/api/dev/dictApi'

export default {
  name: 'EditPrivilegeGroup',
  data() {
    return {
      visible: false,
      relCdOptions: [],
      form: {
        pgId: '',
        name: '',
        description: '',
        relCd: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('role.requiredName'), trigger: 'blur' },
          { min: 2, max: 10, message: this.$t('role.nameLength'), trigger: 'blur' }
        ],
        description: [
          { max: 200, message: this.$t('role.descriptionLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async show(role) {
      this.form = {
        pgId: role.pgId,
        name: role.name,
        description: role.description,
        relCd: role.relCd || ''
      }
      this.visible = true
      await this.loadRelCdOptions()
    },
    async loadRelCdOptions() {
      try {
        const res = await getDictList({
          page: 1,
          row: 10,
          name: '',
          specId: 4
        })
        this.relCdOptions = res.data || []
      } catch (error) {
        console.log('加载字典失败:', error)
        this.$message.error('加载绑定职位选项失败: ' + error.message)
      }
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await updatePrivilegeGroup(this.form)
            this.$message.success(this.$t('role.updateSuccess'))
            this.$emit('success')
            this.visible = false
          } catch (error) {
            this.$message.error(error.message)
          }
        }
      })
    },
    resetForm() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

